import { AppManagementModel } from "../data";

//TODO:DIW:Rename AppDataChangedMessage
export class AppDataChangedMessage {
    public appManagementData: AppManagementModel;

    constructor();
    constructor(appManagementData: AppManagementModel);
    constructor(appManagementData?: AppManagementModel) {

        if (appManagementData !== undefined)
        {
            this.appManagementData = appManagementData;
        }
    }

}